import type { JSX } from 'react';

import { useKnownAvailableParams } from '@change-corgi/core/react/router';
// eslint-disable-next-line internal-rules/no-restricted-design-system-imports
import { Loader } from '@change-corgi/design-system-legacy/components/progressiveDisclosure';

import { withPrefetchedData } from 'src/shared/prefetch';

import type { DecisionMakerProfilePagePrefetchedDataProps } from 'src/app/pages/decisionMakerProfile/pageContext';
import {
	DecisionMakerProfilePageContextProvider,
	prefetchPageContext,
	prefetchPageUserContext,
} from 'src/app/pages/decisionMakerProfile/pageContext';

import { Layout } from '../layout';

import { DecisionMakerProfileErrorHandler } from './ErrorHandler';

export const DecisionMakerProfile = withPrefetchedData(
	function DecisionMakerProfile({
		prefetchedData,
		prefetchedUserData,
	}: DecisionMakerProfilePagePrefetchedDataProps): JSX.Element {
		const { slug } = useKnownAvailableParams<{ slug: string }>();

		return (
			<DecisionMakerProfilePageContextProvider
				slug={slug}
				prefetchedData={prefetchedData}
				prefectedUserData={prefetchedUserData}
				errorHandler={DecisionMakerProfileErrorHandler}
				loadingFallback={<Loader size="m" my={256} mx="auto" />}
			>
				<Layout />
			</DecisionMakerProfilePageContextProvider>
		);
	},
	{
		prefetchName: __MODULE_HASH__,
		// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
		prefetchData: async (context) => prefetchPageContext(context.params.slug!, context),
		prefetchUserData: async (context) => prefetchPageUserContext(context),
	},
);
